export const PROFILE_DETAILS = "PROFILE_DETAILS";
export const DASHBOARD_DETAILS = "DASHBOARD_DETAILS";
export const EXTRA_DETAILS = "EXTRA_DETAILS";